import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

type StylesProps = {
	isEditMode?: boolean
}

const useStyles = makeStyles((theme) => ({
	container: {
		flexDirection: "column"
	},
	radioIcon: (props: StylesProps) => ({
		padding: "10px 10px 10px 10px",
		color: props.isEditMode ? colors.gray[400] : theme.palette.primary.main,
		"&.Mui-checked": {
			color: props.isEditMode ? colors.gray[400] : theme.palette.primary.main
		}
	}),
	categoryOption: {
		display: "flex",
		width: "48%",
		alignItems: "flex-start",
		padding: "10px 10px 10px 0px",
		borderRadius: theme.shape.borderRadius,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		cursor: "pointer"
	},
	input: {
		height: 100
	},
	previewMessageContent: {
		width: "100%",
		maxHeight: 500,
		padding: 10,
		overflowY: "auto",
		borderRadius: 8,
		margin: "5px 5px 5px 0px",
		"&::-webkit-scrollbar": {
			width: "0.25em"
		},
		"&::-webkit-scrollbar-track": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
			borderRadius: "0px 8px 8px 8px"
		},
		"&::-webkit-scrollbar-thumb": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[400]),
			borderRadius: 8,
			border: "2px solid transparent"
		}
	},
	statusChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[200]),
		color: colors.gray[600],
		borderRadius: 7,
		fontSize: 12,
		fontWeight: 400,
		height: 20
	},
	form: {
		paddingRight: 10
	},
	messagePreview: {
		padding: 10,
		flexDirection: "column",
		justifyContent: "start",
		borderRadius: 8,
		position: "sticky"
	},
	disabledOptionOnEditMode: (props: StylesProps) => ({
		color: props.isEditMode ? colors.gray[400] : ""
	}),
	radioOptionText: {
		fontWeight: 600,
		fontSize: 15
	},
	descriptionText: {
		fontSize: 12
	}
}))

export default useStyles
